import { render, staticRenderFns } from "./DodatniSadrzajForma.vue?vue&type=template&id=3de2f671&scoped=true&"
import script from "./DodatniSadrzajForma.vue?vue&type=script&lang=js&"
export * from "./DodatniSadrzajForma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de2f671",
  null
  
)

export default component.exports